import { NgModule } from '@angular/core';
import { ApPaymentFrameComponent } from './components/index';
import { ContentAttributeServiceUpgradeAjsProvider } from './services';

const ajsComponents = [
  ApPaymentFrameComponent,
];

const exportComponents = [
  ...ajsComponents,
];

const declareComponents = [
  ...exportComponents,
];

@NgModule({
  declarations: declareComponents,
  exports: [
    exportComponents,
  ],
  providers: [
    ContentAttributeServiceUpgradeAjsProvider,
  ],
})
export class CoreModule {
  static readonly AjsComponents = ajsComponents;
}
